import firebase from "firebase";
import _ from "lodash";
import {getChildList} from "../utils/getChild";
import dayjs from "dayjs";
import {isCache} from "../plugins/firebase";
import CyrillicToTranslit from 'cyrillic-to-translit-js';

export const getAllInputs = async () => {

  return []
}


const cyrillicToTranslit = new CyrillicToTranslit();


export const getZonesOptions = async (id) => {
  let result = [];

  const path = 'ZONES_' + JSON.stringify({
    id: id
  })

  const cache = localStorage.getItem(path);

  if (!cache || Number(JSON.parse(cache).expire) < dayjs().unix()) {

    const objectsData = await myFirestore
      .collection('projects')
      .doc(id)
      .collection('zones')
      .get();

    await objectsData.forEach((subDoc) => {
      const data = subDoc.data();
      result.push({
        id: subDoc.id,
        name: data.name,
        objects: data.objects,
        index: data.index,
        parentId: data.parentId || undefined,
        isParent: data.isParent,
      });
    });

    if (isCache) {
      localStorage.setItem(path, JSON.stringify({result, expire: dayjs().add(10, 'minute').unix()}))
    }
  } else {
    result = JSON.parse(localStorage.getItem(path)).result
  }

  const r = _.orderBy(getChildList(result), 'index', ['asc']);

  return [
    {
      label: 'Не выбрано',
      id: null,
    },
    ...r.map((r) => {
      return {
        label: r.name,
        value: r.id,
      };
    })
  ];
}

export const addOptionsInputs = async (projectId, id, options) => {
  const projectRef = myFirestore.collection('projects').doc(projectId);
  let batch = myFirestore.batch();

  const optionsCollectionRef = projectRef.collection('inputs').doc(id).collection('optionsList');

  options.forEach(item => {
    const newDocRef = optionsCollectionRef.doc(item.uid);

    batch.set(newDocRef, {
      ...item,
    }, {merge: true});
  });

  await batch.commit()

  return
}

export const addOptionsInputsWithoutResponse = (projectId, id, options) =>{
  addOptionsInputs(projectId, id, options.map((d) => {
    if(d.isCreate) {
      delete d.index
    }

    return d
  }))
}



// WEBPACK FOOTER //
// ./src/firestore/inputs.js